import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import StyledButton from '../styles/StyledButtons'

const TriviaGameAwards = ({ reset, score }) => {
  const [message, setMessage] = useState({
    heading: '',
    statement: '',
  })

  useEffect(() => {
    if (score) {
      setMessage({
        heading: 'Congratulations!',
        statement: `You answered ${score} questions correctly!`,
      })
    } else {
      setMessage({
        heading: 'Oh no!',
        // eslint-disable-next-line quotes
        statement: "You didn't answer any questions correctly.",
      })
    }
  }, [score])

  return (
    <StyledTriviaGameAwards>
      <div className="intro-message">
        <h2>{message.heading}</h2>
        <p>{message.statement}</p>
      </div>
      <div className="controls">
        <StyledButton onClick={() => reset()}>Play Again</StyledButton>
      </div>
    </StyledTriviaGameAwards>
  )
}

const StyledTriviaGameAwards = styled.div`
  .intro-message {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 1.5rem;
  }

  h2 {
    font-size: 1.2rem;
    font-weight: normal;
    margin-top: 0.5rem;
    text-align: center;

    @media screen and (min-width: 37.5em) {
      font-size: 2rem;
      margin-top: 3.5rem;
    }
  }

  p {
    text-align: center;
  }

  .controls {
    display: flex;
    justify-content: center;
  }
`

TriviaGameAwards.propTypes = {
  reset: PropTypes.func.isRequired,
  score: PropTypes.number,
}

TriviaGameAwards.defaultProps = {
  score: 0,
}

export default TriviaGameAwards
